module.exports = __webpack_public_path__ + "img/h.bf3439dd.jpg";